import axios from 'axios';

const token = localStorage.getItem('accessToken');

const apiPay = axios.create({
    baseURL: process.env.VUE_APP_PAY_API,
    headers: { 'Authorization': `bearer ${token}` }
});

export default apiPay;